<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Script-Details') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn slot="activator" @click="openAccoutingDialog()" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down"
                    >Entegrasyon Muhasebe Kodu Ekle</span
                  >
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12 px-2 py-2>
          <v-card class="elevation-6 rounded">
            <v-card-text>
              <v-layout row wrap align-center>
                
                <v-flex xs12 sm12 md7 class="body-1">
                  <span class="body-2">Script : </span>
                  {{ lineItems.LineScript }}
                </v-flex>
                <v-flex xs12 sm12 md3 class="body-1">
                  <span v-if="lineItems.DeptCredit" class="body-2 green--text">
                    Alacak
                  </span>
                  <span v-else class="body-2 red--text"> {{ $t('Debit') }} </span>
                </v-flex>
                <v-flex xs12 sm12 md2 class="pa-0">
                  <v-btn
                    flat
                    @click="openLineUpdate(lineItems.LineID)"
                    icon
                    color="primary"
                    xsmall
                    class="pa-0 ma-0"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-flex
            pa-1
            xs12
            sm12
            md12
            v-for="(item, index) in accountingItems"
            v-bind:key="index"
          >
            <v-hover>
              <v-card
                flat=""
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
                class="mx-auto"
                width="100%"
              >
                <v-card flat="" class="grey--text">
                  <v-card-text>
                    <v-layout row wrap align-center>

                      <!-- <v-flex xs12 sm2 md3>
                        <span class="body-2 font-weight-bold">
                          Masraf Merkezi :
                        </span>
                        <span class="body-1 font-weigh-bold">
                          {{ item.CostCenter }}
                        </span>
                      </v-flex>

                      <v-flex xs12 sm2 md3>
                        <span class="body-2 font-weight-bold">
                          {{ $t('Reference-Centre') }} :
                        </span>
                        <span class="body-1 font-weigh-bold">
                          {{ item.Reference }}
                        </span>
                      </v-flex>

                      <v-flex xs12 sm2 md2>
                        <span class="body-2 font-weight-bold">
                          Bölüm Kodu :
                        </span>
                        <span class="body-1 font-weigh-bold">
                          {{ item.SectionCode }}
                        </span>
                      </v-flex> -->

                      <v-flex xs12 sm2 md2>
                        <span class="body-2 font-weight-bold">
                          {{ $t('Airline-Code') }} :
                        </span>
                        <span class="body-1 font-weigh-bold">
                          {{ item.AirlineCode }}
                        </span>
                      </v-flex>
                      <v-flex xs12 sm2 md5>
                        <span class="body-2 font-weight-bold">
                          Hesap :
                        </span>
                        <span class="body-1 font-weigh-bold">
                          {{ item.AccountingCodeInfo.Code }} - {{ item.AccountingCodeInfo.CodeName }}
                        </span>
                      </v-flex>
                       <v-flex xs12 sm2 md1>
                        <span class="body-2 font-weight-bold" v-if="item.RecordType===0">
                           {{ $t('Ticket') }} 
                        </span>
                        <span class="body-2 font-weight-bold" v-if="item.RecordType===1">
                           {{ $t('Seat') }} 
                        </span>
                         <span class="body-2 font-weight-bold" v-if="item.RecordType===2">
                           {{ $t('Meal') }} 
                        </span>
                          <span class="body-2 font-weight-bold" v-if="item.RecordType===3">
                           {{ $t('Additional-Luggage') }} 
                        </span>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <span class="body-2 font-weight-bold"> {{ $t('VAT') }} % : </span>
                        <span class="body-1 font-weigh-bold">
                          {{ item.TaxRate }}
                        </span>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                      
                      
                        <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
                          flat
                          icon
                          color="primary"
                          class="ma-0"
                          @click="cloneRow(item.ID)"
                          xsmall
                          v-on="on"
                        > 
                        <v-icon>library_add</v-icon>
                      </v-btn>
      
      </template>
      <span >Satırı Kopyala</span>
    </v-tooltip>
                       
                        <v-btn
                          flat
                          icon
                          color="primary"
                          class="ma-0"
                          @click="openAccountingUpdate(item.ID)"
                          xsmall
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn
                          flat
                          icon
                          color="red"
                          class="ma-0"
                          @click="openAccountingDelete(item.ID)"
                          xsmall
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-hover>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>

    <calculatorv2
      ref="calculator"
      @updateResult="UpdateTemplateLine($event)"
    ></calculatorv2>

    <v-layout row justify-center>
      <v-dialog v-model="dialogAccountingDelete" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"> {{ $t('Delete') }} </v-card-title>
          <v-card-text>Silmek istediginize eminmisin ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="DeleteAccounting()"> {{ $t('Delete') }} </v-btn>
            <v-btn color="primary" flat @click="dialogAccountingDelete = false"
              >{{ $t('cancel_button') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="dialogAccountingAdd" persistent max-width="590">
        <v-card>
          <v-card-title class="headline"
            >Entegrasyon Muhasebe Kodu Ekle</v-card-title
          >
          <v-card-text>
            <v-layout row wrap>
         <v-flex xs12 sm6 md12>
                                                            <v-autocomplete :items="itemsKayitTipi" tabindex="12" hide-details="" v-model="accountingParams.RecordType" item-text="Aciklama" item-value="Kod" :label="$t('Record-Type')"></v-autocomplete>
                                                        </v-flex>
              <v-flex xs12 sm12 md12>
                <yuzdeinput
                  :etiket="'Kdv %'"
                  v-model="accountingParams.TaxRate"
                  :autocomplete="'autocomplete'"
                >
                </yuzdeinput>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <havayollaricomp
                  :etiket="$t('Airline-Code')"
                  v-model="havayolubil"
                ></havayollaricomp>
              </v-flex>
                <v-flex xs12 sm12 md12 mt-4>
                <hesapkodu v-model="Accounting" ref="hesapkodu"></hesapkodu>
              </v-flex>
               
              
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="addLineAcconting()"
              >{{ $t('save_button') }}</v-btn
            >
            <v-btn color="primary" flat @click="dialogAccountingAdd = false"
              >{{ $t('cancel_button') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";
import calculatorv2 from "@/components/app/entegrasyon/comp/calculatorv2.vue";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import hesapkodu from "@/components/app/muhasebe/comp/hesapkodu.vue";

export default {
  data() {
    return {
      
      itemsKayitTipi: helpers.getBiletKayitTipi,
      deleteAccountingId: 0,
      Accounting: null,
      dialogLineDelete: false,
      dialogLineUpdate: false,
      dialogAccountingAdd: false,
      dialogAccountingDelete: false,
      dialogTemplate: false,
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      havayolubil: {
        havayolukodu: null,
        formno: null,
      },
      accountingParams: {
        ID: 0,
        TemplateID: 0,
        LineID: 0,
        TaxRate: 0.0,
        AirlineCode: null,
        Reference: null,
        CostCenter: null,
        SectionCode: null,
        AccountingCodeID: 0,
        RecordType:0
      },
      templateLineParams: {
        TemplateID: 0,
        LineID: 0,
        LineScript: null,
      },
      updateDialog: false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      templateDeleteId: 0,
      templateItems: {},
      lineItems: {},
      accountingItems: [],
    };
  },
  methods: {
    openLineUpdate(val) {
      
      var params = {
        TemplateID: this.$route.query.tempId,
        LineID: val,
        LineScript: null,
      };

      this.$refs.calculator.openUpdateDialog(params);
    },
    DeleteAccounting() {
      this.loadingvmodel = true;
      let params = {
        ID: this.deleteAccountingId,
        TemplateID: 0,
        LineID: 0,
        TaxRate: 0.0,
        AirlineCode: null,
        Reference: null,
        CostCenter: null,
        SectionCode: null,
        AccountingCodeID: 0,
      };
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationAccountingCodeDelete",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.getAccountingList();
            this.dialogAccountingDelete = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 =
                "Service Unavailable-IntegrationAccountingCodeDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 =
                "Service Unavailable-IntegrationAccountingCodeDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    openAccountingDelete(id) {
      this.deleteAccountingId = id;
      this.dialogAccountingDelete = true;
    },
    cloneRow(id){
      this.loadingvmodel = true;
      let params = {
        ID: id,
      };
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/CloneLine",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
              this.getAccountingList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-CloneLine";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-CloneLine";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    openAccountingUpdate(id) {
      this.loadingvmodel = true;
      let params = {
        ID: id,
        TemplateID: 0,
        LineID: 0,
        TaxRate: 0.0,
        AirlineCode: null,
        Reference: null,
        CostCenter: null,
        SectionCode: null,
        AccountingCodeID: 0,
      };
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationAccountingCodeLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
           this.accountingParams = response.body;
           
            this.havayolubil.havayolukodu = response.body.AirlineCode;
            this.$refs.hesapkodu.loadHesapKodu(response.body.AccountingCodeID);
            this.dialogAccountingAdd = true;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationAccountingCodeLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationAccountingCodeLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    addLineAcconting() {
     
      console.log(this.Accounting);
      this.accountingParams.TemplateID = this.$route.query.tempId;
      
      this.accountingParams.LineID = this.$route.query.lineId;
      
      this.accountingParams.AirlineCode = this.havayolubil.havayolukodu;
      
      if (this.Accounting.CodeID==null || this.Accounting.CodeID=="undefined")
      {
        this.accountingParams.AccountingCodeID = this.Accounting;
      }
      else{
        this.accountingParams.AccountingCodeID = this.Accounting.CodeID;
      }
      
      
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationAccountingCodeSave",
          this.accountingParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.getAccountingList();
              
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            }
            this.dialogAccountingAdd = false;
           
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationAccountingCodeSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationAccountingCodeSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
          
        );
    },
    openAccoutingDialog() {
      this.accountingParams.ID=0; 
      this.accountingParams.TemplateID= this.$route.query.tempId; 
      this.accountingParams.LineID = this.$route.query.lineId;
      this.accountingParams.TaxRate= 0.0;
      this.accountingParams.AirlineCode= null;
      this.accountingParams.Reference=null;
      this.accountingParams.AccountingCodeID=0;
      this.havayolubil.havayolukodu="";
     
      this.dialogAccountingAdd = true;
    },
    addResult(value) {
      this.templateLineParams.LineScript = value;
    },
    UpdateTemplateLine(value) {
      this.loadingvmodel = true;
      this.templateLineParams.LineScript = value.text;
      this.templateLineParams.DeptCredit = value.deptCredit;
      this.templateLineParams.TemplateID = this.$route.query.tempId;
      this.templateLineParams.LineID = this.$route.query.lineId;
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationTemplateLineSave",
          this.templateLineParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.getDetail();
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            }
            this.dialogLineUpdate = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    addTemplateLine(value) {
      this.loadingvmodel = true;
      this.templateLineParams.LineScript = value;
      this.templateLineParams.TemplateID = this.$route.query.id;
      this.templateLineParams.LineID = 0;
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationTemplateLineSave",
          this.templateLineParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.getDetail();
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    updateDialogOpen() {
      this.templateParams = { ...this.templateItems };
      this.updateDialog = true;
    },
    getAccountingList() {
      this.loadingvmodel = true;

      let params = {
        ID: 0,
        TemplateID: this.$route.query.tempId,
        LineID: this.$route.query.lineId,
        TaxRate: 0.0,
        AirlineCode: null,
        Reference: null,
        CostCenter: null,
        SectionCode: null,
        AccountingCodeID: 0,
      };

      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationAccountingCodeList",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.accountingItems = response.body;
            this.loadingvmodel = false;
            this.dialogTemplate = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationAccountingCodeList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationAccountingCodeList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getDetail() {
      this.loadingvmodel = true;
      let params = {
        TemplateID: this.$route.query.tempId,
        LineID: this.$route.query.lineId,
        DeptCredit: false,
        LineScript: null,
      };

      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationTemplateLineLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.lineItems = response.body;
            this.loadingvmodel = false;
            this.dialogTemplate = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    calculatorv2,
    yuzdeinput,
    masrafmerkezicomp,
    havayollaricomp,
    referansmerkezicomp,
    hesapkodu,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.getAccountingList();
    this.getDetail();
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;

    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

